const BET_DEEP_LINK = /^(?!javascript:)[a-z][a-z0-9+.-]*:\/\//i;

export function isBetDeepLink(href: string): boolean {
  return BET_DEEP_LINK.test(href);
}

export interface BetLinkSet {
  generic?: string | null;
  mobile?: string | null;
  desktop?: string | null;
}

const COURTSIDE_SHARE_LINK = /^https:\/\/api\.courtside\.app\/api\/share\?picks=[^&]+$/;
const COURTSIDE_REFERRAL = "&ref=UPSIDE";

export function withReferral(link: string): string {
  return COURTSIDE_SHARE_LINK.test(link) ? link + COURTSIDE_REFERRAL : link;
}

function firstNonEmpty(...values: (string | null | undefined)[]): string | null {
  for (const value of values) {
    if (typeof value === "string" && value.trim().length > 0) {
      return value;
    }
  }
  return null;
}

export function resolveBetLink(
  set: BetLinkSet | null | undefined,
  isMobile: boolean,
): string | null {
  if (!set) return null;
  return isMobile
    ? firstNonEmpty(set.mobile, set.generic, set.desktop)
    : firstNonEmpty(set.desktop, set.generic, set.mobile);
}

export function toBetLinkSet(
  generic: string | null | undefined,
  mobile: string | null | undefined,
  desktop: string | null | undefined,
): BetLinkSet | null {
  const set: BetLinkSet = {};
  if (typeof generic === "string" && generic.trim()) set.generic = withReferral(generic);
  if (typeof mobile === "string" && mobile.trim()) set.mobile = withReferral(mobile);
  if (typeof desktop === "string" && desktop.trim()) set.desktop = withReferral(desktop);
  return Object.keys(set).length > 0 ? set : null;
}

const LINK_KEYS = ["generic", "mobile", "desktop"] as const;

export function isStoredBetLinks(value: unknown): value is BetLinkSet | null {
  if (value === null) return true;
  if (typeof value !== "object" || Array.isArray(value)) return false;
  return LINK_KEYS.every((key) => {
    const link = (value as Record<string, unknown>)[key];
    return link === undefined || (typeof link === "string" && link.trim() !== "");
  });
}
